import loadable from '@loadable/component';

import withStickyBehavior from './withStickyBehavior';

const ConsumerHeader = loadable(() => import('./ConsumerHeader'));

export default withStickyBehavior(ConsumerHeader);
